// extracted by mini-css-extract-plugin
export default {"NftCard":"NftCard_NftCard__ak8-Q","NftCard__img":"NftCard_NftCard__img__h2A8M","NftCard__container":"NftCard_NftCard__container__0gBe1"};